import { Box, Stack, Typography } from '@mui/material';
import { useState } from 'react';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

import { ModalCarbonBudgetHelp } from '../ModalCarbonBudgetHelp';
import { ProjectVenueCard } from './ProjectVenueCard';

export function ProjectVenueCardCarbonBudget() {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <ModalCarbonBudgetHelp
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
      <ProjectVenueCard title="Budget carbone">
        <Stack sx={{ gap: 2, alignItems: 'center' }}>
          <Box sx={{ py: 1 }}>
            <Typography
              sx={{
                fontSize: '1.25rem',
                textAlign: 'center',
                fontWeight: 800,
                color: ColorsRaw.anthracite.Anthracite_5,
              }}
            >
              {translate('ProjectsVenue.no-carbon-budget-defined')}
            </Typography>
          </Box>
          <FSPrimaryButton
            onClick={() =>
              alert(translate('ProjectsVenue.carbon-budget-not-available-yet'))
            }
          >
            {translate('ProjectsVenue.define-your-carbon-budget')}
          </FSPrimaryButton>
          <FSPrimaryButton color="info" onClick={() => setModalOpen(true)}>
            {translate('ProjectsVenue.why-define-a-carbon-budget')}
          </FSPrimaryButton>
        </Stack>
      </ProjectVenueCard>
    </>
  );
}
